import { toErrorList } from "@rjsf/utils";
import { Validator } from "@cfworker/json-schema";
import processRawValidationErrors from "@rjsf/validator-ajv8/lib/processRawValidationErrors";

export const cfWorkerValidator = {
  toErrorList(errorSchema, fieldPath = []) {
    return toErrorList(errorSchema, fieldPath);
  },

  rawValidation(schema, formData) {
    let validationError = undefined;
    let errors = undefined;

    try {
      const validator = new Validator(schema, '7', false);
      const sanitized = JSON.parse(JSON.stringify(formData ?? {}));
      const result = validator.validate(sanitized);      

      if (!result.valid && result.errors.length > 0) {
        errors = result.errors
          .filter((err) => !err.error.includes('not match schema'))
          .map((err) => {
            let instancePath = err.instanceLocation.replace(/^#/, "");
            
            //parsing of error as per RJSF
            if (err.keyword === "required") {
              const match = err.error.match(/required property "(.+?)"/);
              if (match) {
                const basePath = err.instanceLocation.replace(/^#/, '');
                instancePath = `${basePath}/${match[1]}`;
              }
            }

            return {
              instancePath,
              keyword: err.keyword,
              message: err.error,
              params: {},
              schemaPath: err.keywordLocation,
            };
          });
      }
    } catch (err) {
      validationError = err;
    }

    return { errors, validationError };
  },

  validateFormData(
    formData,
    schema,
    customValidate,
    transformErrors,
    uiSchema,
  ) {
    const rawErrors = this.rawValidation(schema, formData);
    return processRawValidationErrors(
      this,
      rawErrors,
      formData,
      schema,
      customValidate,
      transformErrors,
      uiSchema,
    );
  },

  isValid(schema, formData, rootSchema) {
    try {
      const validator = new Validator(schema);
      const sanitized = JSON.parse(JSON.stringify(formData ?? {}));
      return validator.validate(sanitized).valid;
    } catch (e) {
      return false;
    }
  },
};
